import axios from "axios";

const Axios = axios.create({
  baseURL: "https://api.airtable.com/v0/app70zFDy6EhTi2zS/"
});

const airtableAPIKey = process.env.VUE_APP_AIRTABLEKEY;

Axios.defaults.headers.common = { Authorization: `Bearer ` + airtableAPIKey };

export default {
  getProjects() {
    return Axios.get("Projects");
  },
  getSkills() {
    return Axios.get("Skills");
  },
  getCategories() {
    return Axios.get("Skill Category");
  },
  getProject(slug) {
    return Axios.get("Projects?filterByFormula={Slug}='" + slug + "'");
  }
};
